import { Component, OnInit } from "@angular/core";
import { TipoUsuarioEnum } from "src/app/auth/enum/tipo-usuario.enum";
import { VariablesEnum } from "src/app/auth/enum/variables.enum";
import { UsuarioCultura } from "src/app/models/cultura/usuario-cultura-model";
import { LocalStorageService } from "src/app/services/localstorage.service";
import { RouteInfo } from "./sidebar.metadata";
import { SidebarRoutesService } from "src/app/services/sidebar-routes.service";
import { ROUTES as ROUTES_2025 } from "src/app/shared/sidebar/sidebar-2025-routes.config";
import { AnioInformacionEnum } from "src/app/auth/enum/AnioInformacion.enum";

declare var $: any;

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
  styles: [
    `
      img {
        background: #752a31;
        width: 3.5em !important;
        box-shadow:
          0 3px 6px rgba(0, 0, 0, 0.16),
          0 3px 6px rgba(0, 0, 0, 0.23);
        border-radius: 0.5em;
        margin-top: -0.3em;
      }
    `,
  ],
})
export class SidebarComponent implements OnInit {
  TipoUsuarioEnum = TipoUsuarioEnum;
  public menuItems: RouteInfo[] = [];
  authUS = new UsuarioCultura();
  anioSeleccionado: number;
  anio: Number;
  AnioInformacionEnum = AnioInformacionEnum;

  constructor(
    private localStorageService: LocalStorageService,
    public sidebarRoutesService: SidebarRoutesService,
  ) {}

  async ngOnInit() {
    this.cargarAnioSeleccionado();
    this.cargarUsuarioYMenu();
    this.setTheme();
    $.getScript("./assets/js/app-sidebar.js");
  }

  private cargarAnioSeleccionado(): void {
    const anioSeleccionadoString = localStorage.getItem("anioSeleccionado");

    if (anioSeleccionadoString && anioSeleccionadoString !== "null") {
      this.anio = parseInt(anioSeleccionadoString, 10);
      this.anioSeleccionado = this.anio as number;
    } else {
      localStorage.setItem(
        "anioSeleccionado",
        AnioInformacionEnum.AnioInformacion2025.toString(),
      );
      this.anio = AnioInformacionEnum.AnioInformacion2025;
      this.anioSeleccionado = AnioInformacionEnum.AnioInformacion2025;
    }
  }

  private cargarUsuarioYMenu(): void {
    const sessionConade = this.localStorageService.getJsonValue(
      VariablesEnum.usuario_conade,
    );

    if (sessionConade) {
      // Parsear únicamente si viene en formato string
      this.authUS =
        typeof sessionConade === "string"
          ? JSON.parse(sessionConade)
          : sessionConade;
      this.construirMenu();
    } else {
      const checkInterval = setInterval(() => {
        const retrySession = this.localStorageService.getJsonValue(
          VariablesEnum.usuario_conade,
        );
        if (retrySession) {
          this.authUS =
            typeof retrySession === "string"
              ? JSON.parse(retrySession)
              : retrySession;
          this.construirMenu();
          clearInterval(checkInterval);
        }
      }, 200);

      setTimeout(() => clearInterval(checkInterval), 5000);
    }
  }

  private construirMenu(): void {
    if (!this.authUS || !this.authUS.idTipoUsuario) {
      this.menuItems = ROUTES_2025;
      return;
    }

    if (this.authUS.idTipoUsuario === TipoUsuarioEnum.CONADE) {
      this.menuItems = this.sidebarRoutesService.getCurrentRoutes();

      this.sidebarRoutesService.currentYear$.subscribe((anio) => {
        this.menuItems = this.sidebarRoutesService.getCurrentRoutes();
        this.anioSeleccionado = anio;
      });
    } else if (this.authUS.idTipoUsuario === TipoUsuarioEnum.CONSULTA) {
      localStorage.setItem(
        "idUsuarioConsulta",
        this.authUS.idTipoUsuario.toString(),
      );
      this.menuItems = ROUTES_2025.filter((item) =>
        ["eventos-masivos", "tableros"].some((key) => item.path.includes(key)),
      );
    } else {
      this.menuItems = ROUTES_2025;
    }
  }

  setTheme(): void {
    $("#sidebar-wrapper").attr("class", "sidebar bg-theme bg-theme6");
    $("#active-class").attr("class", "navigation active1");
    $("#header-setting").attr(
      "class",
      "navbar navbar-expand fixed-top color-header bg-theme6",
    );
  }

  public valido(menu: RouteInfo): boolean {
    if (!this.authUS || !this.authUS.idTipoUsuario) return false;

    switch (this.authUS.idTipoUsuario) {
      case TipoUsuarioEnum.CONADE:
        return menu.Conade || false;

      case TipoUsuarioEnum.INSTITUTO:
        return menu.instituto || false;

      case TipoUsuarioEnum.COORDINADOR:
        if (!menu.Coordinador) return false;
        return true;

      case TipoUsuarioEnum.PROMOTOR:
        if (!menu.Promotor) return false;
        const tipo = (this.authUS.TipoCoordinador || "").toLowerCase();
        if (menu.title !== "Eventos masivos" && menu.title !== "Eventos") {
          return tipo !== "eventos masivos";
        } else {
          return tipo === "eventos masivos";
        }
      case TipoUsuarioEnum.CONSULTA:
        return !!menu.Consulta;
      default:
        return false;
    }
  }
}
